import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./InfoSection.css";
import { FaTruck, FaRulerCombined, FaWeightHanging } from "react-icons/fa";
import Image from "../../assets/images/banner.webp";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function InfoSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const cards = [
    {
      icon: <FaTruck size={40} color="#ff6600" />,
      titleKey: "infoSection.cards.0.title",
    },
    {
      icon: <FaRulerCombined size={40} color="#ff6600" />,
      titleKey: "infoSection.cards.1.title",
      descKey: "infoSection.cards.1.desc",
    },
    {
      icon: <FaWeightHanging size={40} color="#ff6600" />,
      titleKey: "infoSection.cards.2.title",
    },
  ];

  return (
    <>
      <section className="py-5 bg-light">
        <Container fluid className="px-4 px-md-5">
          <Row className="align-items-center mb-5">
            <Col md={8}>
              <h3 className="text-orange fw-bold mb-4">
                {t("infoSection.mainTitle")}
              </h3>
              <Row className="g-4">
                {cards.map((card, index) => (
                  <Col xs={12} md={6} lg={4} key={index}>
                    <div className="card-wrapper">
                      <div className="info-card text-center h-100">
                        <div className="icon-wrapper mb-3">{card.icon}</div>
                        <h5 className="fw-bold">{t(card.titleKey)}</h5>
                        {card.descKey && (
                          <p className="text-muted small white-space-pre">
                            {t(card.descKey)}
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col md={4} className="mb-4 mb-md-0 text-md-end">
              <img
                src={Image}
                alt={t("infoSection.imageAlt")}
                className="img-fluid rounded info-img"
              />
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* <Row className="d-flex justify-content-center align-items-center py-5">
        <Col xs={12} md={8} lg={6} data-aos="fade-up">
          <Card className="text-center shadow-lg border-0 p-4 rounded-4">
            <Card.Body>
              <Button
                className="btn-orange btn-xl fw-bold shadow"
                onClick={() => {
                  navigate("/");

                  setTimeout(() => {
                    const formSection =
                      document.getElementById("bookingFormSection");
                    if (formSection) {
                      const firstInput = formSection.querySelector("input");
                      if (firstInput) {
                        const yOffset = -320;
                        const y =
                          firstInput.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;

                        window.scrollTo({ top: y, behavior: "smooth" });

                        setTimeout(() => {
                          firstInput.focus();
                        }, 600);
                      } else {
                        formSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }, 700);
                }}
              >
                {t("infoSection.button")}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
    </>
  );
}
